module.exports = __webpack_public_path__ + "static/media/acceso-internet.f6673fec.pdf";